export const filledArrowDownward = () => (
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_11_5714" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
    <rect width="19" height="19" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_11_5714)">
    <path
      d="M12 12.575L8.1 8.675C7.91667 8.49166 7.68334 8.4 7.4 8.4C7.11667 8.4 6.88334 8.49166 6.7 8.675C6.51667 8.85833 6.425 9.09167 6.425 9.375C6.425 9.65833 6.51667 9.89166 6.7 10.075L11.3 14.675C11.5 14.875 11.7333 14.975 12 14.975C12.2667 14.975 12.5 14.875 12.7 14.675L17.3 10.075C17.4833 9.89166 17.575 9.65833 17.575 9.375C17.575 9.09167 17.4833 8.85833 17.3 8.675C17.1167 8.49166 16.8833 8.4 16.6 8.4C16.3167 8.4 16.0833 8.49166 15.9 8.675L12 12.575Z"
      fill="#1C1B1F"
    />
  </g>
</svg>
)

export const filledArrowUpward = () => (
<svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_11_5713" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
<rect width="19" height="19" fill="#0095FF"/>
</mask>
<g mask="url(#mask0_11_5713)">
<path d="M12 10.8L8.1 14.7C7.91667 14.8833 7.68334 14.975 7.4 14.975C7.11667 14.975 6.88334 14.8833 6.7 14.7C6.51667 14.5167 6.425 14.2833 6.425 14C6.425 13.7167 6.51667 13.4833 6.7 13.3L11.3 8.7C11.5 8.5 11.7333 8.4 12 8.4C12.2667 8.4 12.5 8.5 12.7 8.7L17.3 13.3C17.4833 13.4833 17.575 13.7167 17.575 14C17.575 14.2833 17.4833 14.5167 17.3 14.7C17.1167 14.8833 16.8833 14.975 16.6 14.975C16.3167 14.975 16.0833 14.8833 15.9 14.7L12 10.8Z" fill="#0095FF"/>
</g>
</svg>

);


export const filledArrowDownwardWhite = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_11_5714" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="10">
    <rect width="10" height="10" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_11_5714)">
    <path
      d="M12 12.575L8.1 8.675C7.91667 8.49166 7.68334 8.4 7.4 8.4C7.11667 8.4 6.88334 8.49166 6.7 8.675C6.51667 8.85833 6.425 9.09167 6.425 9.375C6.425 9.65833 6.51667 9.89166 6.7 10.075L11.3 14.675C11.5 14.875 11.7333 14.975 12 14.975C12.2667 14.975 12.5 14.875 12.7 14.675L17.3 10.075C17.4833 9.89166 17.575 9.65833 17.575 9.375C17.575 9.09167 17.4833 8.85833 17.3 8.675C17.1167 8.49166 16.8833 8.4 16.6 8.4C16.3167 8.4 16.0833 8.49166 15.9 8.675L12 12.575Z"
      fill="#fffff"
    />
  </g>
</svg>
)